<div class="d-flex flex-row gap-3 align-items-center justify-content-center privacy-policy">
  <a target="_blank" rel="noopener noreferrer" href="https://www.cmgfi.com/corporate/privacy-policy">Privacy Policy</a>
  <i class="pi pi-circle-fill"></i>
  <a target="_blank" rel="noopener noreferrer" href="https://www.cmgfi.com/corporate/terms-of-use">Terms of Use</a>
</div>
<p class="text-center mb-0">
  CMG Mortgage, Inc. dba CMG Home Loans dba CMG Financial, NMLS# 1820, is an equal housing lender. Licensed by the Department of Financial Protection
  and Innovation (DFPI) under the California Residential Mortgage Lending Act No. 4150025. To verify our complete list of state licenses, please visit
  <a target="_blank" rel="noopener noreferrer" href="https://www.cmgfi.com/corporate/licensing">www.cmgfi.com/corporate/licensing</a> and
  <a target="_blank" rel="noopener noreferrer" href="https://www.nmlsconsumeraccess.org">www.nmlsconsumeraccess.org</a>. This site is not intended to
  serve as a business solicitation for residents in the states of Massachusetts and New York
</p>
